// extracted by mini-css-extract-plugin
export default {"element":"Introduction-module--element--5c32c","container":"Introduction-module--container--0a7e4","wide":"Introduction-module--wide--79a14"};